<template>
  <p class="confirmation__title">Datenschutz</p>
  <p class="confirmation__subtitle">
    Zur Anzeige der Karte von <a href="https://www.mapbox.com/" target="_blank">Mapbox</a> (<a
      href="https://www.mapbox.com/legal/privacy"
      target="_blank"
      >Mapbox Datenschutzbestimmungen</a
    >) benötigen wir Ihre Einwilligung.
  </p>
  <Button class="mapbox-cookie-dialog__button" label="Einwilligen" @clicked="acceptClickHandler" />
  <p class="mapbox-cookie-dialog__bottom">
    Detaillierte Informationen über den Einsatz von Cookies auf dieser Webseite erhalten Sie in
    unserer <a href="https://www.oeamtc.at/datenschutz" target="_blank">Datenschutzerklärung</a> und
    den <a href="" @click="cookieSettingsClickHandler">Cookie-Einstellungen</a>.
  </p>
</template>

<script>
import Button from '@/components/Button.vue'
import { showMapboxServiceInfo, acceptMapboxService } from '@/utils/user-centrics'

export default {
  components: { Button },
  methods: {
    acceptClickHandler() {
      acceptMapboxService(() => {
        this.$store.commit('setInitMap', true)
        this.$store.commit('setShowMapboxCookieDialog', false)
      })
    },
    cookieSettingsClickHandler(e) {
      e.preventDefault()
      showMapboxServiceInfo()
    },
  },
}
</script>

<style lang="scss">
.mapbox-cookie-dialog {
  &__button {
    margin-bottom: 24px;
    width: 100%;
  }

  &__bottom {
    border-top: 1px solid $color-grey-light;
    color: $color-text-secondary;
    font-size: 12px;
    padding-top: 12px;
  }
}
</style>
